import { render, staticRenderFns } from "./Survey2.vue?vue&type=template&id=ec3abc76&"
import script from "./Survey2.vue?vue&type=script&lang=ts&"
export * from "./Survey2.vue?vue&type=script&lang=ts&"
import style0 from "./Survey2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports